import React from 'react'
import logo from 'images/logo.png'

const Header = () => {
  return (
    <div>
      <header className="center">
        <img src={logo} alt="breaking brad"/>
      </header>
    </div>
  )
}

export default Header
